import * as React from 'react';

type TruncateTextProps = {
    text: string;
    lines: number;
};
// if text in a div is longer than x lines it will be
// truncated down to x lines and end with an ellipsis
export default function useTruncateText({ text, lines }: TruncateTextProps) {
    const textRef = React.useRef<HTMLDivElement>();
    const [isOverflowing, setIsOverflowing] = React.useState(false);

    React.useEffect(() => {
        const descriptionElement = textRef.current;
        if (descriptionElement) {
            const lineHeight = parseInt(
                window.getComputedStyle(descriptionElement).lineHeight,
                10,
            );
            const maxHeight = lineHeight * (lines + 1);

            if (
                descriptionElement?.offsetHeight &&
                descriptionElement.offsetHeight > maxHeight
            ) {
                setIsOverflowing(true);
                while (descriptionElement.offsetHeight > maxHeight) {
                    descriptionElement.textContent =
                        descriptionElement.textContent?.replace(
                            /\W*\s(\S)*$/,
                            '...',
                        ) ?? '';
                }
            } else {
                setIsOverflowing(false);
            }
        }
    }, [lines, text]);

    return { isOverflowing, ref: textRef };
}
